// extracted by mini-css-extract-plugin
export const wrapper = "projects-module--wrapper--1B9kM";
export const title = "projects-module--title--28UUM";
export const highlighted = "projects-module--highlighted--2hwjD";
export const projectImage = "projects-module--projectImage--RJT7X";
export const grid = "projects-module--grid--No4Cm";
export const slide = "projects-module--slide--1-97c";
export const smHidden = "projects-module--smHidden--APhGX";